import { render, staticRenderFns } from "./vue-extend-layout.vue?vue&type=template&id=722a58f5&"
import script from "./vue-extend-layout.vue?vue&type=script&lang=js&"
export * from "./vue-extend-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports